import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { fetchBadFitResolutionReasonTableAndFilterSchema } from "model/BadFitResolutionReasonModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const BadFitResolutionReasonContext = createContext();

export const BadFitResolutionReasonProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [badFitResolutionReasonContextData, setBadFitResolutionReasonContextData] =
    useState();

  const fetchBadFitResolutionReasonContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema(
        "metadata:badFitResolutionReason",
        () => fetchBadFitResolutionReasonTableAndFilterSchema([])
      );
      if (response?.success) {
        setBadFitResolutionReasonContextData(response?.data);
      }
    } catch (err) {
      setError(err);
      toast.error(err?.message || "Failed to load bad fit resolution reason metadata");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([]);
    };
    fetchAll();
  }, []);

  return (
    <BadFitResolutionReasonContext.Provider
      value={{
        fetchBadFitResolutionReasonContextData,
        badFitResolutionReasonContextData,
        loading,
        error,
      }}
    >
      {children}
    </BadFitResolutionReasonContext.Provider>
  );
};

export const useBadFitResolutionReasonContext = () =>
  useContext(BadFitResolutionReasonContext);
